export const friendlyGoogleErrorMessage = (message) => {
  if (!message) return 'An unknown error occurred.';
  if (message.includes('REQUIRED_BUSINESS_NAME_ASSET_NOT_LINKED')) {
    return 'Cannot remove the last Business Name. At least one Business Name must remain linked to the campaign.';
  }
  if (message.includes('REQUIRED_LOGO_ASSET_NOT_LINKED')) {
    return 'Cannot remove the last Logo. At least one Logo must remain linked to the campaign.';
  }
  if (message.includes('ASPECT_RATIO_NOT_ALLOWED')) {
    return 'One or more selected images do not match the required aspect ratio for their asset type. Open the campaign’s Asset Group tab — images flagged in red show the actual ratio and what was expected.';
  }
  // stringLengthError is emitted by the proxy layer that wraps the Google Ads API response
  if (message.includes('TOO_LONG') || message.includes('stringLengthError')) {
    return 'One or more text assets exceed the character limit for their assigned category. Open the campaign’s Asset Group tab — text assets flagged in red show the length and the limit.';
  }
  return message;
};
